import { jsxs, jsx } from 'react/jsx-runtime';
import { useId } from '@reach/auto-id';
import classNames from 'classnames';
import { useRef, useEffect } from 'react';
import { Typography } from '../Typography/typography.js';

const Checkbox = ({
  checked,
  className,
  defaultChecked,
  description,
  indeterminate,
  isDisabled,
  label,
  onChange,
  ...props
}) => {
  const uniqueId = useId(props.id);
  const checkboxId = `checkbox--${uniqueId || "id"}`;
  const checkboxRef = useRef(null);
  useEffect(() => {
    if (indeterminate !== void 0 && checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(
        "axiom-checkbox",
        isDisabled ? "axiom-checkbox--disabled" : ""
      ),
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            checked,
            className: classNames("axiom-checkbox__input", className),
            defaultChecked,
            disabled: isDisabled,
            id: checkboxId,
            onChange,
            ref: checkboxRef,
            type: "checkbox",
            ...props
          }
        ),
        label && /* @__PURE__ */ jsx(
          Typography,
          {
            className: "axiom-checkbox__label",
            ...{ htmlFor: checkboxId },
            tag: "label",
            type: description ? "subhead" : "body",
            children: label
          }
        ),
        description && /* @__PURE__ */ jsx(
          Typography,
          {
            className: "axiom-checkbox__description",
            tag: "div",
            type: "body",
            children: description
          }
        )
      ]
    }
  );
};
Checkbox.displayName = "Checkbox";

export { Checkbox };
